<template>
	<olb-button linkStyle :href="href">
		<olb-icon class="text-icon-sm leading-1" name="arrow-nav-left"></olb-icon>
		<span class="block pb-px"><slot></slot></span>
	</olb-button>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import OlbButton from '../button';
import OlbIcon from '../icon';

export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
	},
	props: {
		href: String,
	},
});
</script>
